<template>
  <van-nav-bar
      class="cbacknav"
      placeholder
      :title="title"
      left-arrow
      @click-left="onClickLeft"
  />
</template>

<script>
export default {
  name: "CBackNav",
  props:{
    title:{
      type: String,
      default: ''
    },
    autoBack:{
      type: Boolean,
      default: true,
    }
  },
  methods:{
    onClickLeft(){
      this.$emit("back",{})
      if(this.autoBack)
        this.$router.back()
    }
  }
}
</script>

<style scoped>
.cbacknav >>> .van-icon{
  color: #000000;
}
</style>